<template>
    <div class="mt-5 mb-5">
        <legend v-if="only_view">Прикріплені файли</legend>
        
        <fileloader
            key="file_load_app"
            :doc_id="protocol.id"
            doc_type="protocol"
            :url_remove="tender_file_url"
            :url_load="tender_file_url"
            v-bind:trigger_load="file_trigger"
            v-bind:can_del="true"
            :enable-preview=false
            :simpleLoader="true"
            :files="[]"
        >
        </fileloader>
        
        <BTable class="small_tr" :key="'app_files'" striped
                :items="request_files"
                :fields="fields" v-if="request_files.length > 0">
            
            
            <template v-slot:cell(file.name)="{ value, item, field: { key }}">
                <a href="#" v-on:click.prevent.default="getFile(item)">
                    {{item.name}}
                </a>
            </template>
            
            <template v-slot:cell(description)="{ value, item, field: { key }}">
                <BFormInput :disabled="only_view" v-model="item[key]" type="text" placeholder="Опис файла"/>
            </template>
            
            <template v-slot:cell(dell_row)="row">
                <div class='icon-stack cursor-pointer fs-xxl' v-on:click="dellFile(row.item)" v-if="!only_view">
                    <i class="base base-1 icon-stack-3x opacity-100 color-danger-600"></i>
                    <i class="far fa-trash-alt icon-stack-1x opacity-100 color-white"></i>
                </div>
                
                <div class="text-right"  v-else>
                    <div class="icon-stack cursor-pointer fs-xxl "  v-on:click="getFile(row.item)">
                        <i class="base base-1 icon-stack-3x opacity-100 color-primary-600"></i>
                        <i class="far fa-save icon-stack-1x opacity-100 color-white"></i>
                    </div>
                </div>
            </template>
        </BTable>
    </div>
</template>

<script>

import fileloader from "../../../../shared/file_loader/fileloader.vue";

import {
    BTable,
    BFormGroup,
    BFormInput,
} from 'bootstrap-vue-next';
export default {
    name: "protocol_files",
    components: {fileloader,BTable,BFormGroup,BFormInput},
    props : {
        protocol : {
            type : Object,
            required : true
        },
        
        only_view : {
            type : Boolean,
            default : false,
        },
    },
    
    emits : ['changeAtr'],
    
    data() {
        return {
            files : [],
            "file_trigger" : "loadedAppDoc",
            fields: [
                {key: 'file.name', label: 'Файл'},
                {key: 'description', label: 'Примітка'},
                {key: 'dell_row', label: '',}
            ]
        }
    },
    
    created() {
        EventBus.$on(this.file_trigger,this.operateLoad);
    },
    
    methods : {
        
        getFile(file) {
            console.log(file);
            window.location.href = '/internal/media/file/' + file.file_id;
        },
        
        async operateLoad(info) {
            let file_id = info.file_id;
            let full_file = info.full_file;
            console.log('trigger',info);
            
            if(info.type === 'file_loaded') {
                this.request_files.push({
                    'name'          : full_file?.name,
                    'file_id'       : file_id,
                    'description'   : "",
                    'file' : {
                        'name' : full_file?.name,
                    }
                });
                this.files = [];
            }
            
            if(info.type === 'file_deleted') {
                const arr = this.tender.request.files;
                const idx = arr.findIndex(f => Number(f.file_id) === file_id);
                if (idx !== -1) arr.splice(idx, 1);
                
                console.log(this.request_files);
            }
        },
        
        async dellFile(file) {
            console.log('remove',file);
            await api.delete(this.tender_file_url + '/' + parseInt(file.file_id)).then(({data}) => {
                this.operateLoad({
                    'type' : "file_deleted",
                    file_id : file.file_id
                });
            }).catch(e => {
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            })
        }
    },
    
    computed: {
        tender_file_url () {
            return '/tenders/sales/protocols/' + this.protocol.id + "/file";
        },
        
        request_files() {
            return   this.protocol.files;
        },
    }
}
</script>



<style scoped>

</style>